import HttpService from "./Http.service";

export default class PatientService {
	public static getAll(page: number): Promise<Response> {
		return HttpService.get(`/patient?page=${page}&size=1000`);
	}
}
